<template>
  <BaseButtonIcon
    outline
    :title="$t('product_events.ADD_TO_CALENDAR')"
    :aria-label="$t('product_events.ADD_TO_CALENDAR')"
    size="small"
    @click="handleClick"
  >
    <CalendarAddIcon />
  </BaseButtonIcon>
</template>

<script setup lang="ts">
import { downloadCourseCalendar, type EventDate } from '@/service/v3/endpoints/events'
import { toRefs } from 'vue'
import { type ToastOptions } from '@/hooks/useToast'
import { useUtilityHelpers } from '@/hooks/useUtilityHelpers'
import BaseButtonIcon from '@/components/generics/base/BaseButtonIcon.vue'
import CalendarAddIcon from '@/components/icon_components/CalendarAddIcon.vue'

const props = defineProps<{ date: EventDate }>()

const { date } = toRefs(props)

const {
  asyncWrapper,
  doToast: addedToCalendarToast,
  contentLocale,
  i18n,
} = useUtilityHelpers()

const successfulToast: ToastOptions = {
  text: i18n.t('product_events.ADDED_TO_CALENDAR'),
}

const handleClick = async () => {
  await asyncWrapper(addEvent)
  addedToCalendarToast(successfulToast)
}

const addEvent = async () => {
  if (!date.value.id) return
  await downloadCourseCalendar(date.value.id, contentLocale.value)
}
</script>
